import { FormHelperText, ThemeProvider, createTheme, styled } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

function container() {
  // Use the fullscreen element if in fullscreen mode, otherwise just the document's body
  return document.fullscreenElement ?? document.body;
}

const SimpleSelectForm = ({
  value,
  name,
  onChange,
  options,
  label,
  showLabel = true,
  required = false,
  hasHelperText = false,
  helperText,
  helperTextClasses = "",
}) => {
  return (
    <FormControl
      fullWidth
      sx={{
        ".MuiFormLabel-root": {
          fontSize: "14px !important",
        },

        ".MuiFormLabel-colorPrimary": {},
        ".MuiMenu-list": {
          backgroundColor: "black",
        },
        "MuiFormLabel-root": {},
        ".MuiInputLabel-root": {},
      }}
    >
      {showLabel && (
        <InputLabel
          id="select-category"
          sx={{
            "MuiFormLabel-root": {},
            ".MuiInputLabel-root": {},
          }}
        >
          {label}
        </InputLabel>
      )}
      <Select
        sx={{
          width: "100%",

          fontSize: "14px",
          ".MuiSvgIcon-root": {},
          ".MuiPaper-root": {
            backgroundColor: "black",
          },
          ".MuiList-root": {
            backgroundColor: "black",
          },
          "MuiFormLabel-root": {},
          ".MuiInputLabel-root": {},
        }}
        id={label}
        labelId={label}
        label={label}
        value={value}
        required={required}
        onChange={onChange}
        name={name}
        className="capitalize"
      >
        {options.map((item, index) => {
          return (
            <MenuItem key={index} value={item} className="capitalize">
              {item}
            </MenuItem>
          );
        })}
      </Select>
      {hasHelperText && <FormHelperText className={helperTextClasses}>{helperText}</FormHelperText>}
    </FormControl>
  );
};
export default SimpleSelectForm;
